<template>
  <div class="links text-light flex-column">
    <header>
      <img class="img" :src="require(`@/assets/logos/logo-secondary.png`)" width="250">
      <div class="subtitle-4">Encontre o que está procurando</div>
    </header>
    <div class="flex-column align-center">
      <a v-for="(button, index) in buttons" :key="index" :href="button.href">
        <button class="btn-primary">{{ button.label }}</button>
      </a>
    </div>
  </div>
</template>

<script>
import api from '@/services/api'

export default {
  name: 'Links',
  data () {
    return {
      apiLinks: []
    }
  },
  computed: {
    buttons () {
      return this.apiLinks.map(link => ({
        label: link.label,
        href: link.url,
        isExternal: link.isExternal
      }))
    }
  },
  async created () {
    await this.fetchLinks()
  },
  methods: {
    async fetchLinks () {
      try {
        const data = await api.getLinks()
        if (data && data.links) {
          this.apiLinks = data.links
        }
      } catch (error) {
        console.error('Erro ao carregar links:', error)
        this.apiLinks = []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .links {
    .subtitle-4 {
      margin: 20px 0;
      opacity: .8;
      font-size: 16px;
    }
    .btn-primary {
      background: #C3C3C3;
      color: #3e3e3e;
      margin-top: 20px;
      min-width: 290px;
      min-height: 50px;
    }
  }
</style>